import tw from 'tailwind-styled-components';
import styled from 'styled-components';
import { Text } from './../../Typography';
import { ReactNode } from 'react';

export const ContainerListing = tw.div`
  w-11/12
  mx-auto
  max-w-3xl
  border-b
  border-corporate-blue
  py-10
  space-y-4
`;

export const ContainerSubline = styled.div`
  width: 100%;
  & > * {
    color: #292b29;
    text-transform: uppercase;
  }
`;
export const ImageContainer = styled.div<{
  children?: ReactNode;
  className?: string;
}>`
  width: 100%;
  height: 50vw;
  @media screen and (min-width: 768px) {
    max-width: calc(100% / 3);
    height: 170px;
  }
`;

export const MarketChip = tw(Text)`
  py-1
  px-4
  rounded-2xl
`;
